import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import type { ComissaoResponse } from './response/comissao.response';
import type { ComissaoFiltroRequest } from './request/comissao-filtro.request';
import type { ComissaoCadastroRequest } from './request/comissao-cadastro.request';

export interface RealizarPagamentoRequest {
  idComissao: number;
  comprovanteBase64: string;
}

export interface ObterComprovanteResponse {
  comprovanteBase64: string;
}

@Injectable({ providedIn: 'root' })
export class ComissaoService extends BaseService {
  private ComissaoEndpoint = `${environment.urlEdducaImobApi}api/Comissao/`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Obtém comissões filtradas para o Parceiro (baseado no usuário logado)
   */
  async obtemComissaoFiltrada(request: ComissaoFiltroRequest): Promise<Array<ComissaoResponse>> {
    const params = new HttpParams({ fromObject: {
      idUsuario: request.idUsuario?.toString() ?? '',
      dataInicial: request.dataInicial ? request.dataInicial.toISOString() : '',
      dataFinal: request.dataFinal ? request.dataFinal.toISOString() : '',
    }});
  
    return await firstValueFrom(
      this.http.get<Array<ComissaoResponse>>(`${this.ComissaoEndpoint}ObtemComissaoFiltrada`,{ headers: this.getHeader(true), params })
    );
  }

  /**
   * Obtém todas as comissões para ADM_SISTEMA (visão geral)
   */
  async obtemTodasComissoes(request: ComissaoFiltroRequest): Promise<Array<ComissaoResponse>> {
    const paramsObj: Record<string, string> = {};
    
    if (request.dataInicial) {
      paramsObj['dataInicial'] = request.dataInicial.toISOString();
    }
    if (request.dataFinal) {
      paramsObj['dataFinal'] = request.dataFinal.toISOString();
    }
    if (request.idStatusComissao !== null && request.idStatusComissao !== undefined) {
      paramsObj['idStatusComissao'] = request.idStatusComissao.toString();
    }
    
    const params = new HttpParams({ fromObject: paramsObj });
    const url = `${this.ComissaoEndpoint}ObtemTodasComissoes`;
  
    return await firstValueFrom(
      this.http.get<Array<ComissaoResponse>>(url, { headers: this.getHeader(true), params })
    );
  }

  /**
   * Realiza o pagamento de uma comissão (ADM_SISTEMA)
   */
  realizarPagamento(request: RealizarPagamentoRequest): Observable<void> {
    return this.http.post<void>(
      `${this.ComissaoEndpoint}RealizarPagamento`,
      request,
      { headers: this.getHeader(true) }
    );
  }

  /**
   * Obtém o comprovante de pagamento de uma comissão
   */
  async obterComprovante(idComissao: number): Promise<ObterComprovanteResponse> {
    return await firstValueFrom(
      this.http.get<ObterComprovanteResponse>(
        `${this.ComissaoEndpoint}ObterComprovante/${idComissao}`,
        { headers: this.getHeader(true) }
      )
    );
  }

  adicionarComissao(request: ComissaoCadastroRequest): Observable<void> {
    return this.http.post<void>(
      `${this.ComissaoEndpoint}AdicionarComissao`,
      request,
      { headers: this.getHeader(true) }
    );
  }
}
